import { useEffect, useState } from 'react';
import { fetchPublicFeatureFlags } from '../services/featureFlagsApi';
import { isPublicFeatureFlagEnabled, normalizeFeatureFlags } from '../constants/featureFlags';
import { useStaffRoles } from './useStaffRoles';

/**
 * Non-admins need the feature flag enabled. Admins always have access.
 */
export function useStaffFeatureFlagAccess(flagKey) {
  const { isAdmin } = useStaffRoles();
  const [allowed, setAllowed] = useState(isAdmin);
  const [loading, setLoading] = useState(!isAdmin);

  useEffect(() => {
    if (isAdmin) {
      setAllowed(true);
      setLoading(false);
      return undefined;
    }

    let mounted = true;

    (async () => {
      try {
        const flags = normalizeFeatureFlags(await fetchPublicFeatureFlags());
        if (mounted) {
          setAllowed(isPublicFeatureFlagEnabled(flags, flagKey));
        }
      } catch {
        if (mounted) {
          setAllowed(false);
        }
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      mounted = false;
    };
  }, [isAdmin, flagKey]);

  return { allowed, loading, isAdmin };
}
